import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations files
import en from "../locales/en/translation.json";
import ptBR from "../locales/pt-BR/translation.json";
import es from "../locales/es/translation.json";
import de from "../locales/de/translation.json";
import fr from "../locales/fr/translation.json";

const resources = {
  en: {
    translation: en,
  },
  "pt-BR": {
    translation: ptBR,
  },
  es: {
    translation: es,
  },
  de: {
    translation: de,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.REACT_APP_ENV === "development",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    pluralSeparator: "_",
    contextSeparator: "_",
    interpolation: {
      escapeValue: false,
    },
    returnObjects: true,
    lng: undefined, // Let detector choose
    keySeparator: ".",
    nsSeparator: ":",
  });

export default i18n;
